import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { QuantityPerSize } from 'swag-client-common/components/partials/quantity-per-size';
import { ShortUnderlineInput } from 'swag-client-common/components/inputs/pink-underline-input';
import { MultipleProductsSelectionError } from '../multiple-products-selection-error';
import { ColorLabelWithTooltip } from '../color-label-with-tooltip';
import classes from './multiple-product-selection-for-color.scss';
import animationClasses from './appear.anim.scss';
export const MultipleProductSelectionForColorComponent = ({
  colorValue,
  colorName,
  colorVariantId,
  parentId,
  error,
  quantitiesData: {
    availableQuantities,
    selectedQuantities,
    outOfStockSizes
  },
  bundleQuantities,
  selectedQuantitiesInfo,
  hasSizes,
  setQuantity,
  blurQuantity,
  sizeSettings,
  isSelected,
  isLastSelected
}) => {
  function onChangeQuantity(value, selectedQuantityObject) {
    if (!selectedQuantityObject) {
      return null;
    }
    if (String(value).length >= 7) {
      return null;
    }
    const number = Number(value);
    if (!Number.isFinite(number)) {
      return null;
    }
    if (number < 0) {
      return null;
    }
    setQuantity({
      quantity: Number(value),
      variantId: selectedQuantityObject.variantId
    });
  }
  function onBlurQuantity(data) {
    if (!data) {
      return;
    }
    blurQuantity({
      id: colorVariantId || parentId,
      touched: true
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.wrapper, {
      [classes.isShown]: isSelected,
      [classes.isLastSelected]: isLastSelected
    })
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    in: isSelected,
    classNames: animationClasses,
    unmountOnExit: true,
    timeout: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.row,
    key: colorValue
  }, hasSizes ? /*#__PURE__*/React.createElement("div", {
    className: classes.multipleQuantities
  }, /*#__PURE__*/React.createElement(ColorLabelWithTooltip, {
    tooltipClassname: classes.tooltipClassname,
    colorLabelBlockClassname: classes.colorLabelBlock,
    colorLabelTextClassname: classes.colorLabelText,
    name: colorName,
    value: colorValue
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.quantityPerSize
  }, /*#__PURE__*/React.createElement(QuantityPerSize, {
    colorName: colorName,
    sizeContainerClassName: classes.container,
    inputClassName: classes.input,
    titleClassName: classes.title,
    subTitleClassName: classes.subTitle,
    sizeItemClassName: classes.sizeItem,
    sizeItemInputClassName: classes.sizeItemInput,
    sizeItemInputWrapperClassName: classes.sizeItemWrapperInput,
    bundleQuantities: bundleQuantities,
    errorClassName: classes.error,
    inStockQuantities: availableQuantities,
    sizes: sizeSettings,
    quantities: selectedQuantities,
    outOfStockSizes: outOfStockSizes,
    onBlur: sizeIndex => onBlurQuantity(selectedQuantitiesInfo[sizeIndex]),
    onChange: ({
      value,
      sizeIndex
    }) => {
      onChangeQuantity(value, selectedQuantitiesInfo[sizeIndex]);
    }
  })), /*#__PURE__*/React.createElement(MultipleProductsSelectionError, {
    error: error
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.singleQuantity
  }, /*#__PURE__*/React.createElement(ColorLabelWithTooltip, {
    tooltipClassname: classes.tooltipClassname,
    colorLabelBlockClassname: classes.colorLabelBlock,
    colorLabelTextClassname: classes.colorLabelText,
    name: colorName,
    value: colorValue
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.inputWithError)
  }, /*#__PURE__*/React.createElement(ShortUnderlineInput, {
    dataColorName: colorName,
    className: classes.input,
    dataInput: "Quantity",
    value: selectedQuantities[0],
    onBlur: () => onBlurQuantity(selectedQuantitiesInfo[0]),
    onChange: e => {
      onChangeQuantity(e.target.value, selectedQuantitiesInfo[0]);
    }
  }), /*#__PURE__*/React.createElement(MultipleProductsSelectionError, {
    className: classes.singleInputError,
    error: error
  }))))));
};